
import React, { useEffect, useState } from 'react';
import logo from '../assets/logo.png';
import Footer from '../components/Footer';
import AnniversaryIntro from '../components/AnniversaryIntro';
import { Link } from 'react-router-dom';
import { useLocation } from 'react-router-dom';
import { getBanners } from '../api';
import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000';
const JOB_SEEKER_NUMBER = '8943 493 493';
const HIRING_TALENTS_NUMBER = '9745 85 9745';

// ── Registration form data lists ─────────────────────────────────────────────
const KERALA_PLACES = [
  // Thiruvananthapuram
  'Thiruvananthapuram','Kazhakoottam','Attingal','Neyyattinkara','Nedumangad','Varkala','Kattakada','Nemom','Kovalam','Vizhinjam','Karamana','Sreekaryam','Pattom','Kowdiar','Peroorkada','Parassala','Pothencode','Venganoor','Aruvippuram','Thumba','Thiruvallam','Ulloor','Balaramapuram','Pangode','Kazhakuttam','Technopark','Fort','Palayam','Vanchiyoor','Thampanoor','Anayara',
  // Kollam
  'Kollam','Punalur','Karunagappally','Kottarakkara','Paravur','Kottiyam','Ayoor','Kundara','Perinad','Chadayamangalam','Chavara','Sasthamkotta','Mynagappally','Kulathupuzha','Anchal','Ummannoor',
  // Pathanamthitta
  'Pathanamthitta','Adoor','Thiruvalla','Ranni','Pandalam','Kozhencherry','Konni','Mallappally','Maramon','Aranmula','Chengannur','Tiruvalla','Vennikulam','Puthuppally','Niranam','Elanthoor',
  // Alappuzha
  'Alappuzha','Alleppey','Cherthala','Kayamkulam','Harippad','Mannar','Ambalappuzha','Mavelikkara','Changanassery','Pandanad','Kainakary','Purakkad','Kuttanad','Haripad','Aryankavu','Karuvatta','Muttar',
  // Kottayam
  'Kottayam','Changanacherry','Pala','Vaikom','Muvattupuzha','Erattupetta','Kanjirappally','Ettumanoor','Mundakayam','Ponkunnam','Karukachal','Athirampuzha','Kumarakom','Thodupuzha','Meenachil','Kanjirappally','Kudamaloor',
  // Idukki
  'Thodupuzha','Munnar','Kattappana','Adimali','Neriyamangalam','Painavu','Rajakkad','Devikulam','Nedumkandam','Upputhara','Vandiperiyar','Kumily','Peermade','Udumbanchola','Idukki','Azhutha',
  // Ernakulam
  'Kochi','Ernakulam','Aluva','Angamaly','Perumbavoor','Kothamangalam','Thrippunithura','Kalamassery','Edappally','Kakkanad','Vytilla','Fort Kochi','Mattancherry','Elamakkara','Kaloor','Palarivattom','Vyttila','Maradu','Eloor','North Paravur','Munambam','Koovappady','Piravom','Varappuzha','Kadamakudy','Cheranalloor','Mulanthuruthy','Okkal','Kuruppampady','Manjapra','Chottanikkara','Karumalloor','Njarakkal','Keerampara','Rayamangalam',
  // Thrissur
  'Thrissur','Irinjalakuda','Chalakudy','Guruvayur','Kodungallur','Kunnamkulam','Mala','Wadakkanchery','Chavakkad','Kecheri','Valapad','Pavaratty','Pariyaram','Puthukkad','Nadathara','Ollur','Cherpu','Arimpur','Pongam','Thrissur Town','Viyyur','Perinjanam','Pazhayannur','Mathilakam','Chowannur','Manalur',
  // Palakkad
  'Palakkad','Ottapalam','Shoranur','Mannarkkad','Pattambi','Alathur','Chittur','Nemmara','Kongad','Kalpathy','Malampuzha','Mundur','Sreekrishnapuram','Vadakkencherry','Thrithala','Puthunagaram','Perinthalmanna','Lakkidi','Attappadi','Kuzhalmannam','Parali','Shornur',
  // Malappuram
  'Malappuram','Manjeri','Tirur','Perinthalmanna','Kondotty','Nilambur','Ponnani','Kottakkal','Areekode','Tanur','Valanchery','Tirurrangadi','Vengara','Parappanangadi','Tirurangadi','Kalpakanchery','Edappal','Tenhipalam','Karuvarakundu','Thiruvali','Pulikkal','Angadipuram',
  // Kozhikode
  'Kozhikode','Calicut','Vadakara','Koyilandy','Ramanattukara','Feroke','Beypore','Thamarassery','Mukkam','Thiruvambadi','Kunnamangalam','Narikkuni','Chelannur','Koduvally','Perambra','Mavoor','Kallachi','Balussery','Koorachundu','Payyoli','Quilandy','Vatakara',
  // Wayanad
  'Kalpetta','Mananthavady','Sulthan Bathery','Vythiri','Ambalavayal','Meenangadi','Padinharethara','Panamaram','Noolpuzha','Pulpally','Kambalakad','Meppadi','Kaniyambetta','Begur','Poothadi',
  // Kannur
  'Kannur','Thalassery','Payyannur','Iritty','Koothuparamba','Anthoor','Mattannur','Chelora','Valapattanam','Dharmadom','Chala','Pattuvam','Peravoor','Kalliasseri','Taliparamba','Sreekandapuram','Payyanur','Chapparapadavu','Thripangottur','Azhikkal',
  // Kasaragod
  'Kasaragod','Kanhangad','Manjeshwaram','Nileshwar','Hosdurg','Cheruvathur','Udma','Bekal','Vidyanagar','Ajanur','Badiadka','Kasaragod Town','Mogral Puthur','Valiyaparamba','Trikaripur','Pilicode',
];

const QUALIFICATIONS = [
  'SSLC / 10th','Plus Two / +2 / Higher Secondary','Plus Two - Science','Plus Two - Commerce','Plus Two - Humanities / Arts',
  'ITI (Industrial Training)','Diploma in Engineering','Diploma in Computer Applications (DCA)','Diploma in Pharmacy','Diploma in Nursing','Diploma in Hotel Management',
  'B.A. (Bachelor of Arts)','B.Com (Bachelor of Commerce)','B.Sc (Bachelor of Science)','BBA (Bachelor of Business Administration)','BCA (Bachelor of Computer Applications)',
  'B.Tech (Bachelor of Technology)','B.E. (Bachelor of Engineering)','B.Arch (Bachelor of Architecture)','B.Ed (Bachelor of Education)',
  'B.Pharm (Bachelor of Pharmacy)','B.Sc Nursing','BHM (Bachelor of Hotel Management)','LLB (Bachelor of Laws)',
  'B.P.T. (Physiotherapy)','BAMS (Ayurveda)','BHMS (Homeopathy)','MBBS','BDS (Dental)','B.Sc Psychology','B.Sc Agriculture','B.Sc Microbiology','B.Sc Biochemistry',
  'M.A. (Master of Arts)','M.Com (Master of Commerce)','M.Sc (Master of Science)','MBA (Master of Business Administration)',
  'MCA (Master of Computer Applications)','M.Tech (Master of Technology)','M.E. (Master of Engineering)',
  'M.Ed (Master of Education)','M.Pharm','M.Sc Nursing','LLM (Master of Laws)',
  'MD (Doctor of Medicine)','MS (Master of Surgery)','MDS (Dental Surgery)','M.Arch',
  'PGDM (Post Graduate Diploma in Management)','Post Graduate Diploma','Ph.D',
  'CA Foundation','CA Intermediate','CA Final (Chartered Accountant)',
  'CMA Foundation','CMA Intermediate','CMA Final (Cost Accountant)',
  'CS Foundation','CS Executive','CS Professional (Company Secretary)',
  'ACCA (UK)','CFA (Chartered Financial Analyst)','CFP (Certified Financial Planner)',
  'Certificate Course (Computer)','Certificate Course (Other)',
];

const JOB_ROLES = [
  'Accountant','Accounts Assistant','Accounts Executive','Accounts Payable Specialist','Accounts Receivable Specialist',
  'Administrative Assistant','Administrative Executive','Area Sales Manager','Architect','Auditor','AutoCAD Operator',
  'Backend Developer','Bank Clerk','Bank PO','BDM (Business Development Manager)','BDE (Business Development Executive)',
  'Branch Manager','Business Analyst','CA Article Assistant','Call Centre Executive','Cashier','Chef / Cook',
  'Civil Engineer','Civil Site Engineer','Clinical Pharmacist','CNC Machine Operator','Computer Hardware Technician',
  'Computer Operator','Content Writer','Corporate Trainer','Cost Accountant','Counter Sales Executive','Credit Officer',
  'Customer Relationship Manager','Customer Service Executive','Data Analyst','Data Entry Operator',
  'Digital Marketing Executive','Driver','Electrical Engineer','Electrical Technician','Electronics Engineer',
  'Electronics Technician','Estimator (Civil)','Executive Assistant','Export/Import Executive','Factory Worker',
  'Field Sales Executive','Finance Executive','Finance Manager','Front Office Executive','Full Stack Developer',
  'General Manager','Graphic Designer','GST Consultant','HR Executive','HR Manager','HVAC Technician',
  'Interior Designer','IT Support Engineer','Junior Accountant','Junior Engineer','Junior Software Developer',
  'Lab Technician','Loan Officer','Logistics Executive','Machine Operator','Management Trainee','Manager',
  'Marketing Executive','Marketing Manager','Mechanical Engineer','Medical Representative','Merchandiser',
  'Network Administrator','Nurse (GNM / B.Sc)','Office Assistant','Operations Executive','Operations Manager',
  'Pharmacist','Plumber','Production Engineer','Production Supervisor','Project Coordinator','Project Manager',
  'Purchase Executive','Purchase Manager','Quality Analyst','QA Engineer','Quality Control Inspector',
  'Radiographer','Receptionist','Regional Sales Manager','Safety Officer','Sales Coordinator','Sales Executive',
  'Sales Manager','SAP Consultant','Security Guard','SEO Executive','Site Engineer','Social Media Manager',
  'Software Developer','Software Tester / QA','Store Incharge','Store Keeper','Supervisor',
  'System Administrator','Tax Consultant','Teacher / Faculty','Team Leader','Technician','Telecaller',
  'Transport Manager','UI/UX Designer','Videographer / Photographer','Warehouse Executive',
  'Web Developer','Welder','X-Ray Technician','Zonal Manager',
];

const DEPARTMENTS = [
  'Accounts & Finance','Administration','Audit & Compliance','Banking & Finance','Business Development',
  'Civil Engineering','CNC Machine Operations','Computer Science & IT','Content & Communication',
  'Customer Service & Support','Data Analytics & MIS','Design & Architecture','Digital Marketing',
  'Education & Training','Electrical Engineering','Electronics & Instrumentation','Export & Import',
  'Fabrication & Welding','Field Operations','Finance & Taxation','FMCG / Retail',
  'Front Office & Hospitality','HR & Payroll','Insurance','Legal','Logistics & Supply Chain',
  'Maintenance & Repair','Manufacturing & Production','Marketing & Branding','Mechanical Engineering',
  'Medical & Healthcare','NBFC & Microfinance','Operations','Pharmacy','Purchase & Procurement',
  'Quality Control & QA','Research & Development','Sales','Security','Software Development',
  'Stores & Inventory','Tele Marketing & Call Centre','Transport & Delivery','Warehouse & Dispatch',
];

const DEPT_SECTIONS = {
  'Accounts & Finance': ['Accounts Payable','Accounts Receivable','Billing & Invoicing','Bank Reconciliation','Budgeting & Forecasting','Cost Accounting','Financial Reporting','GST & Taxation','Tally Operations','Payroll Processing','Internal Audit','MIS Reporting'],
  'Civil Engineering': ['Site Supervision','Drawing & Estimation','Structural Design','AutoCAD','BOQ Preparation','MEP Works','Quality & Safety','Project Management','Survey & Layout','Tendering'],
  'Software Development': ['Frontend Development','Backend Development','Full Stack Development','Mobile App Development','QA & Testing','DevOps','Database Administration','UI/UX Design','Cybersecurity','Cloud Computing','API Development'],
  'Computer Science & IT': ['Software Development','Network Administration','Database Administration','IT Support & Helpdesk','Cybersecurity','Cloud & Infrastructure','Business Analysis','ERP Implementation'],
  'HR & Payroll': ['Recruitment & Staffing','Training & Development','Payroll Processing','Employee Relations','Performance Management','Compliance & Labour Law','Induction & Onboarding','HR MIS'],
  'Sales': ['Field Sales','Retail Sales','B2B Sales','Tele Sales','Pre-Sales','After-Sales Support','Sales Coordination','Channel Sales','Counter Sales'],
  'Marketing & Branding': ['Digital Marketing','SEO & SEM','Social Media Marketing','Brand Management','Content Marketing','Offline Marketing','Lead Generation','Market Research','Advertising & Promotions'],
  'Manufacturing & Production': ['Production Planning','Quality Control','Stores','Safety','Process Control','Assembly','Finishing','Packing & Dispatch','Machine Operations'],
  'Mechanical Engineering': ['Design & CAD','Maintenance','Production','Quality Inspection','Fabrication','Tool Room','CNC Programming','HVAC','Welding & Fitting'],
  'Electrical Engineering': ['Power Distribution','Wiring & Installation','PLC/SCADA','Panel Building','Maintenance','Quality & Testing','Project Supervision'],
  'Customer Service & Support': ['Customer Relations','After-Sales Support','Technical Support','CRM','Feedback & Escalation','Chat Support','Email Support'],
  'Logistics & Supply Chain': ['Procurement','Warehouse Management','Dispatch & Delivery','Fleet Management','Import & Export','Inventory Control','Order Processing'],
  'Banking & Finance': ['Loans & Advances','Deposits','Teller Operations','KYC & AML','Insurance Bancassurance','Treasury','Credit Appraisal','Recovery & Collections'],
  'Medical & Healthcare': ['OPD / Outpatient','ICU / Critical Care','Emergency','Lab & Pathology','Pharmacy','Radiology & Imaging','Nursing Station','Operation Theatre','Admin & Medical Records'],
  'Administration': ['Office Management','Facilities Management','Reception & Front Desk','Documentation & Filing','Travel & Logistics','Procurement & Vendor Management','Executive Support'],
  'Business Development': ['Lead Generation','Client Acquisition','Proposal Writing','Market Expansion','Partnerships & Alliances','Key Account Management','Pricing & Negotiation'],
  'Digital Marketing': ['SEO','SEM / Google Ads','Social Media Marketing','Email Marketing','Content Creation','Video Marketing','Analytics & Reporting','Affiliate Marketing'],
  'Purchase & Procurement': ['Vendor Development','Tender & Quotation','Purchase Order Management','Material Planning','Import Procurement','Contract Management','Cost Negotiation'],
  'Warehouse & Dispatch': ['Receiving & Inspection','Storage & Bin Management','Picking & Packing','Dispatch Operations','Inventory Audit','Returns Processing'],
  'Stores & Inventory': ['Stock Management','Material Issue & Receipt','Inventory Control','Bin Card Maintenance','Spares Management'],
  'Quality Control & QA': ['Incoming Quality','In-Process Quality','Final Inspection','Documentation & Audit','Lab Testing','Calibration','ISO Compliance','NABL'],
  'Audit & Compliance': ['Internal Audit','Statutory Audit','Tax Audit','GST Compliance','ROC Filings','Risk Assessment','Process Audit'],
  'Finance & Taxation': ['Income Tax','GST','TDS & TCS','Financial Analysis','Investment Advisory','Audit Support'],
  'Education & Training': ['Teaching (Primary)','Teaching (Secondary)','Teaching (Higher Education)','Technical Training','Soft Skills Training','E-Learning','Administration','Library'],
  'NBFC & Microfinance': ['Business Correspondent','Loan Origination','Field Collection','Recovery','Branch Operations','Credit Analysis','Customer Onboarding'],
  'Front Office & Hospitality': ['Reception','Reservations','Guest Relations','Concierge','Food & Beverage Service','Housekeeping','Banquet Operations'],
  'Design & Architecture': ['Architectural Design','3D Modelling & Rendering','AutoCAD Drawing','Interior Design','Landscape Design','Urban Planning','Graphic Design'],
  'Insurance': ['Life Insurance','General Insurance','Health Insurance','Motor Insurance','Claims Processing','Underwriting','Agency Development'],
  'Legal': ['Corporate Law','Civil Litigation','Criminal Law','Property & Conveyancing','Labour Law','Intellectual Property','Contract Drafting'],
  'Transport & Delivery': ['Local Delivery','Intercity Transport','Fleet Operations','Route Planning','Vehicle Maintenance','Documentation'],
  'CNC Machine Operations': ['CNC Turning','CNC Milling','CNC Programming (G-Code)','Tool Setting','Quality Inspection','Machine Maintenance'],
  'Fabrication & Welding': ['MIG Welding','TIG Welding','ARC Welding','Sheet Metal Fabrication','Structural Fabrication','Gas Cutting','Quality Inspection'],
  'Field Operations': ['Field Survey','Site Operations','Field Sales','Maintenance & Repair','Ground Operations','Data Collection'],
  'Security': ['Premises Security','Access Control','CCTV Monitoring','Patrolling','Fire Safety','VIP Protection'],
  'Content & Communication': ['Content Writing','Copywriting','Technical Writing','Proofreading & Editing','Social Media Content','Video Scripting','PR & Media'],
  'Data Analytics & MIS': ['MIS Reporting','Data Entry & Cleansing','Dashboard & Visualisation','Advanced Excel','Power BI','SQL & Database','Python / R Analytics'],
  'Electronics & Instrumentation': ['PCB Design','Embedded Systems','Industrial Instrumentation','PLC Programming','Maintenance','Testing & QC'],
  'Export & Import': ['Customs Clearance','Shipping Documentation','Freight Coordination','Letter of Credit','Export Compliance','Trade Finance'],
  'Pharmacy': ['Dispensing','Drug Store Management','Clinical Pharmacy','Regulatory Affairs','Quality Assurance','Pharmacovigilance'],
  'Research & Development': ['Product Development','Process Research','Market Research','Testing & Validation','Documentation & Patents'],
  'Tele Marketing & Call Centre': ['Inbound Support','Outbound Sales','Lead Generation','Customer Retention','Collections','Technical Helpdesk'],
  'Maintenance & Repair': ['Preventive Maintenance','Breakdown Maintenance','Civil Maintenance','Electrical Maintenance','Mechanical Maintenance','AMC Coordination'],
  'FMCG / Retail': ['Store Operations','Inventory Management','Merchandising','Sales Floor','Category Management','Vendor Relations'],
};
const ALL_SECTIONS = [...new Set(Object.values(DEPT_SECTIONS).flat())].sort();

const homeHighlights = [
  {
    title: 'Recruitment Support',
    description: 'Clear hiring support for employers looking for faster shortlisting and better candidate matching.'
  },
  {
    title: 'Career Guidance',
    description: 'Structured help for candidates who need direction, profile support, and better placement readiness.'
  },
  {
    title: 'Practical Services',
    description: 'From staffing to resume creation, every service is designed for usable outcomes.'
  }
];

const homeStats = [
  { value: '10+', label: 'Live recent jobs tracked on the home page' },
  { value: '1:1', label: 'Candidate support with practical follow-up' },
  { value: 'Fast', label: 'Response for hiring and service enquiries' }
];

const supportPanels = [
  {
    title: 'For Employers',
    description: 'Share your hiring need and get support for sourcing, screening, and staffing coordination.'
  },
  {
    title: 'For Job Seekers',
    description: 'Register once and make your profile easier to review, shortlist, and forward for openings.'
  },
  {
    title: 'Direct Contact',
    description: `Call ${JOB_SEEKER_NUMBER} for candidate support or ${HIRING_TALENTS_NUMBER} for hiring support.`
  }
];

const initialRegistrationForm = {
  name: '',
  email: '',
  place: '',
  contact_number: '',
  whatsapp_number: '',
  district: '',
  highest_qualification: '',
  expecting_job: '',
  department: '',
  section: '',
  resume: null,
  photo: null
};

const Home = (props) => {
  const location = useLocation();
  const [banners, setBanners] = useState([]);
  const [currentBanner, setCurrentBanner] = useState(0);
  const [recentJobs, setRecentJobs] = useState([]);
  const [jobsLoading, setJobsLoading] = useState(true);
  const [scrollingText, setScrollingText] = useState('');

  useEffect(() => {
    axios.get(`${API_URL}/api/scrolling-text`).then(r => setScrollingText(r.data.text || '')).catch(() => {});
  }, []);
  // Registration modal is now global in App.js

  useEffect(() => {
    getBanners().then(res => setBanners(res.data)).catch(() => setBanners([]));
  }, []);

  useEffect(() => {
    let isMounted = true;

    const fetchRecentJobs = async (showLoader = false) => {
      if (showLoader) setJobsLoading(true);
      try {
        const res = await axios.get(`${API_URL}/api/jobs`);
        if (isMounted) {
          setRecentJobs((res.data || []).slice(0, 20));
        }
      } catch {
        if (isMounted) {
          setRecentJobs([]);
        }
      } finally {
        if (showLoader && isMounted) {
          setJobsLoading(false);
        }
      }
    };

    fetchRecentJobs(true);
    const intervalId = setInterval(() => {
      fetchRecentJobs();
    }, 15000);

    return () => {
      isMounted = false;
      clearInterval(intervalId);
    };
  }, []);

  // Simple auto-advance for banners
  useEffect(() => {
    if (banners.length > 1) {
      const interval = setInterval(() => {
        setCurrentBanner(b => (b + 1) % banners.length);
      }, 3500);
      return () => clearInterval(interval);
    }
  }, [banners]);

  // Registration form logic is now handled globally in App.js

  // Use openRegisterModal from props

  // Registration modal open/close is handled globally in App.js

  const marqueeJobs = recentJobs.length > 0 ? [...recentJobs, ...recentJobs] : [];

  return (
    <>
      <AnniversaryIntro />
      <div className="min-h-screen bg-white flex flex-col items-center text-secondary font-official">
      {/* Banner carousel */}
      {banners.length > 0 && (
        <div className="w-full" style={{height: '500px', marginBottom: '1rem', marginTop: '0'}}>
          <img
            src={banners[currentBanner].image_url.startsWith('http') ? banners[currentBanner].image_url : `${process.env.REACT_APP_API_URL || 'http://localhost:5000'}${banners[currentBanner].image_url}`}
            alt={banners[currentBanner].title || `Banner ${currentBanner+1}`}
            className="w-full h-full object-cover"
            style={{transition: 'all 0.5s', width: '100%', height: '100%'}}
            onError={e => { e.target.onerror = null; e.target.src = logo; }}
          />
          <div className="absolute left-0 right-0 bottom-2 flex justify-center gap-2" style={{position: 'absolute'}}>
            {banners.map((_, idx) => (
              <button
                key={idx}
                className={`w-3 h-3 rounded-full ${idx === currentBanner ? 'bg-yellow-400' : 'bg-gray-300'}`}
                onClick={() => setCurrentBanner(idx)}
                aria-label={`Go to banner ${idx+1}`}
              />
            ))}
          </div>
        </div>
      )}


      {/* Scrolling text ticker */}
      {scrollingText && (
        <div className="w-full bg-black overflow-hidden py-2.5">
          <div className="scrolling-ticker-track whitespace-nowrap">
            <span className="text-yellow-400 font-bold text-sm tracking-wide px-8">{scrollingText}&nbsp;&nbsp;&nbsp;★&nbsp;&nbsp;&nbsp;{scrollingText}&nbsp;&nbsp;&nbsp;★&nbsp;&nbsp;&nbsp;{scrollingText}&nbsp;&nbsp;&nbsp;★</span>
          </div>
        </div>
      )}

      <section className="relative z-20 mb-6 w-full px-4 md:px-8">
        {/* Quick Contact Section (first after banner) */}
        <div className="mx-auto max-w-7xl rounded-[30px] border border-yellow-200 bg-[linear-gradient(135deg,#fffef7_0%,#fff8de_42%,#ffffff_100%)] px-5 py-4 shadow-[0_18px_45px_rgba(196,154,18,0.12)] md:px-8 md:py-5">
          <div className="flex flex-col gap-5 lg:flex-row lg:items-start lg:justify-between">
            <div className="max-w-2xl">
              <p className="text-xs font-extrabold uppercase tracking-[0.24em] text-yellow-700 md:text-sm">Quick Contact</p>
              <h2 className="mt-2 text-3xl font-black tracking-tight text-black md:text-4xl">Speak to the right team faster</h2>
              {/* Removed text about separate contact support for job seekers and hiring teams */}
            </div>
            <Link
              to="/contact"
              className="inline-flex items-center justify-center self-start rounded-xl border border-gray-300 bg-white px-5 py-3 text-sm font-bold text-black transition hover:border-yellow-500 hover:text-yellow-700"
            >
              Contact Page
            </Link>
          </div>

          <div className="mt-4 grid grid-cols-1 gap-4 xl:grid-cols-3">
            <div className="rounded-[26px] border border-yellow-200 bg-white px-5 py-5 shadow-sm">
              <p className="text-[11px] font-extrabold uppercase tracking-[0.28em] text-gray-500">Job Seeker Support</p>
              <p className="mt-3 text-3xl font-black tracking-tight text-yellow-700 md:text-4xl">{JOB_SEEKER_NUMBER}</p>
              <p className="mt-2 text-sm leading-6 text-gray-600">Registration support, profile help, and guidance for job seekers.</p>
              <a
                href="tel:8943493493"
                className="mt-4 inline-flex items-center justify-center rounded-xl bg-yellow-400 px-5 py-3 text-sm font-extrabold text-black transition hover:bg-yellow-300"
              >
                Call Job Seeker Team
              </a>
            </div>

            <div className="rounded-[26px] border border-gray-200 bg-[linear-gradient(135deg,#fff 0%,#f8fafc 100%)] px-5 py-5 shadow-sm">
              <p className="text-[11px] font-extrabold uppercase tracking-[0.28em] text-gray-500">Hiring Talent Support</p>
              <p className="mt-3 text-3xl font-black tracking-tight text-black md:text-4xl">{HIRING_TALENTS_NUMBER}</p>
              <p className="mt-2 text-sm leading-6 text-gray-600">Direct support for employers looking to hire, shortlist, and fill roles faster.</p>
              <a
                href="tel:9745859745"
                className="mt-4 inline-flex items-center justify-center rounded-xl border border-black px-5 py-3 text-sm font-extrabold text-black transition hover:border-yellow-500 hover:text-yellow-700"
              >
                Call Hiring Team
              </a>
            </div>

            <div className="rounded-[26px] border border-yellow-200 bg-[linear-gradient(135deg,#fff9e8_0%,#ffffff_100%)] px-5 py-5 shadow-sm">
              <p className="text-[11px] font-extrabold uppercase tracking-[0.28em] text-gray-500">Resume And Profile Writing</p>
              <p className="mt-3 text-2xl font-black tracking-tight text-black md:text-3xl">8943 555 655</p>
              <p className="mt-2 text-sm leading-6 text-gray-600">Resume and profile writing services for candidates who need stronger presentation and better shortlisting support.</p>
              <p className="mt-3 text-sm font-semibold text-gray-700">Email: danijobclub@gmail.com</p>
              <div className="mt-4 flex flex-wrap gap-3">
                <a
                  href="tel:8943555655"
                  className="inline-flex items-center justify-center rounded-xl bg-yellow-400 px-5 py-3 text-sm font-extrabold text-black transition hover:bg-yellow-300"
                >
                  Call Service Team
                </a>
                <a
                  href="mailto:danijobclub@gmail.com"
                  className="inline-flex items-center justify-center rounded-xl border border-gray-300 px-5 py-3 text-sm font-bold text-black transition hover:border-yellow-500 hover:text-yellow-700"
                >
                  Send Email
                </a>
              </div>
            </div>
          </div>
        </div>

        {/* Recent Jobs Carousel Section (now after quick contact) */}
        {recentJobs.length > 0 && (
          <section className="w-full px-4 md:px-8 mb-10">
            <div className="mx-auto max-w-7xl rounded-[30px] border border-yellow-200 bg-gradient-to-br from-yellow-50 via-white to-yellow-100 px-5 py-6 shadow-[0_18px_45px_rgba(196,154,18,0.10)]">
              <div className="flex items-center justify-between mb-4">
                <div>
                  <p className="text-xs font-extrabold uppercase tracking-[0.24em] text-yellow-700 md:text-sm mb-1">Recent Jobs</p>
                  <h2 className="text-2xl md:text-3xl font-black text-black">Latest openings</h2>
                </div>
                <Link to="/jobs" className="inline-flex items-center rounded-xl bg-yellow-400 px-5 py-2 text-sm font-extrabold text-black hover:bg-yellow-300 transition">View All Jobs</Link>
              </div>
              <div className="overflow-hidden w-full">
                <div className="recent-jobs-marquee-track" style={{ minWidth: '100%' }}>
                  {[...recentJobs.slice(0, 20), ...recentJobs.slice(0, 20)].map((job, idx) => (
                    <Link
                      to="/jobs"
                      key={job.id + '-' + idx}
                      className="group flex flex-col min-w-[260px] max-w-[280px] rounded-[20px] border border-gray-200 bg-white p-4 shadow-[0_12px_30px_rgba(0,0,0,0.08)] transition hover:-translate-y-1 hover:border-yellow-300 hover:shadow-[0_18px_36px_rgba(250,204,21,0.16)] relative"
                      style={{ textDecoration: 'none' }}
                    >
                      {job.category && (
                        <span className="absolute top-4 right-4 bg-yellow-100 text-yellow-700 text-[10px] font-bold px-2.5 py-1 rounded-full uppercase tracking-wide">{job.category}</span>
                      )}
                      <div className="mb-3 pr-2">
                        <h3 className="text-lg font-bold text-yellow-700 leading-snug uppercase tracking-wide">{job.title}</h3>
                      </div>
                      <div className="grid grid-cols-2 gap-2 text-xs mb-2">
                        <div className="rounded-2xl bg-gray-50 px-2.5 py-1.5">
                          <p className="text-gray-500 font-semibold">Location</p>
                          <p className="text-black font-bold mt-0.5">{job.location || '-'}</p>
                        </div>
                        <div className="rounded-2xl bg-gray-50 px-2.5 py-1.5">
                          <p className="text-gray-500 font-semibold">District</p>
                          <p className="text-black font-bold mt-0.5">{job.district || '-'}</p>
                        </div>
                        <div className="rounded-2xl bg-gray-50 px-2.5 py-1.5">
                          <p className="text-gray-500 font-semibold">Experience</p>
                          <p className="text-black font-bold mt-0.5">{job.experience || '-'}</p>
                        </div>
                        <div className="rounded-2xl bg-gray-50 px-2.5 py-1.5">
                          <p className="text-gray-500 font-semibold">Salary</p>
                          <p className="text-black font-bold mt-0.5">{job.salary || '-'}</p>
                        </div>
                        <div className="rounded-2xl bg-gray-50 px-2.5 py-1.5 col-span-2">
                          <p className="text-gray-500 font-semibold">Qualification</p>
                          <p className="text-black font-bold mt-0.5">{job.qualification || '-'}</p>
                        </div>
                        <div className="rounded-2xl bg-gray-50 px-2.5 py-1.5">
                          <p className="text-gray-500 font-semibold">Gender</p>
                          <p className="text-black font-bold mt-0.5">{job.gender || '-'}</p>
                        </div>
                        <div className="rounded-2xl bg-gray-50 px-2.5 py-1.5">
                          <p className="text-gray-500 font-semibold">Age Limit</p>
                          <p className="text-black font-bold mt-0.5">{job.age_limit || '-'}</p>
                        </div>
                      </div>
                      {job.company_firm_organisation && (
                        <div className="text-xs text-gray-700 mb-2">
                          <span className="font-semibold">Company / Firm / Organisation</span><br/>
                          {job.company_firm_organisation}
                        </div>
                      )}
                      {job.description && (
                        <div className="text-xs text-gray-600 mt-auto">{job.description}</div>
                      )}
                    </Link>
                  ))}
                </div>
              </div>
            </div>
          </section>
        )}
      </section>

      {/* All modal and orphaned JSX removed. Main content ends here. */}




      {/* Removed 'Why People Use Dani Job Club' and 'Special Focus' sections as requested */}
      </div>
      <Footer />
    </>
  );
};

export default Home;
